/**
 * @generated SignedSource<<5dac256c177ba923ffeb32a5b7d54a77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPane_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly country: string | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPane_buyer";
};
export type CheckoutMobileSummaryNewPane_buyer$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPane_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPane_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPane_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "2ad9f9334fe519c00f43a5d1bfc32d51";

export default node;
